import React, { Component } from 'react';
import { UncontrolledCollapse, Container, Col, Row, ListGroup, ListGroupItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import Spinner from "../reusable/Loader";
import { getStatePage } from '../../utilitarios/util';
import localStorageCustom from '../../utilitarios/localStorage';
export class PedidoFinalizado extends Component {
  static displayName = PedidoFinalizado.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      pedido: {
        pedidos: []
      }
    };
  }
  IrDashboard = async () => {
    this.props.history.push('/generar-pedido');
  }
  IrListado = async () => {
    this.props.history.push('/carrito');
  }
  checkParams() {

    const { state } = this.props.location;
    if (state != undefined) {
      let _datosPedido = state.datosPedido;
      console.log("_datosPedido====>", _datosPedido);
      this.setState({
        pedido: _datosPedido.datosPedido
      });
    }
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0);
      this.checkParams();
    } else
      window.location.href = "/";
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { loading, pedido } = this.state;

    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Pedido Finalizado</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.push('/generar-pedido')} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Pedido finalizado</h6>
          <div className="card container_1000">
            <div className="pedido_finalizado">
              <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
              <SvgAssets icon="icon-check" className='icon-block' fill={c.verdeClaro} />
              <h4 className="mb-4 title-4 verde desktop_parrafo1">Gracias! Tu pedido ha sido reservado con éxito.</h4>
              <p className="paragraph-3 desktop_parrafo2 light" style={{ color: c.grisMedio }}>
                Tu pedido con <span className="bold" style={{ color: c.azulClaro }}> N° {pedido.pedidosStr}</span> ha sido generado con éxito. Estará reservado hasta las {pedido.horaStr} del {pedido.diaStr} de {pedido.mesStr} del {pedido.anioStr}. De no realizar el pago antes de dicho momento, el pedido se cancelará.
              </p>
              <div className="card_pedido_finalizado">
                {pedido.pedidos.map((item, index) => {
                  return (
                    <Row key={"item_pedido_" + index} form>
                      <Col xs={6}>
                        <span className='paragraph-3' style={{ color: c.azulClaro }}>Código de pedido:</span>
                        <span className='paragraph-3 bold' style={{ color: c.azulClaro }}>{item.vbeln}</span>
                      </Col>
                      <Col xs={6}>
                        <span className='paragraph-3' style={{ color: c.azulClaro }}>Fecha máxima de pago: </span>
                        <span className='paragraph-3 bold' style={{ color: c.azulClaro }}>{item.fecmpStr} {item.hormpStr}</span>
                      </Col>
                    </Row>
                  )
                })}

                <p className="importe light" style={{ color: c.azulClaro }}>Importe a pagar: <span className="bold" style={{ color: c.verdeClaro }}>
                  {pedido.importeStr}</span></p>
              </div>
              <p className="paragraph-3 desktop_parrafo2 light" style={{ color: c.grisMedio }}>
                Realizado el pago iniciará el proceso de atención. Visualizar el proceso en <strong>“Historial de pedidos”</strong>
              </p>
              <div className="mobile">
                <button className='btn-block bg_verde'
                  type="button"
                  onClick={() => this.IrDashboard()}
                >SEGUIR COMPRANDO</button>
              </div>
            </div>
          </div>
          <div className="desktop mt-5">
            <button className='btn-block bg_verde'
              type="button"
              onClick={() => this.IrDashboard()}
            >SEGUIR COMPRANDO</button>
          </div>
        </Container>
      </div>
    );
  }
}
